import { IconPack } from "SuperAdmin/Config/Icon";
import { Select, Spin, Tag } from "antd";
import { getSearchUnits } from "Explore/Services/Unit";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import styles from "./SelectComponents.module.scss";

const SelectManagementScopeUnit = ({ placeholder, form, filter }) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  const [isLoading, setIsLoading] = useState(false);
  const [chosenData, setChosenData] = useState(null);
  const renderItem = (value) => {
    const data = value.data;
    return (
      <div
        className={styles["management-scope-item"]}
        onClick={() => handleSelectScope(data)}
      >
        <div className={styles["management-scope-info"]}>
          <p className={styles["management-scope-name"]}>{data?.name}</p>
          <p>{data?.institution_name}</p>
          <Tag>Level {data.level}</Tag>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (debouncedValue) {
      setIsLoading(true);
      setOptions([]);
      const payload = {
        query: debouncedValue,
        institution_name_ls: filter,
      };
      getSearchUnits(payload, (res) => {
        setOptions(res.results);
        setIsLoading(false);
      });
    }
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleSelectScope = (value) => {
    setChosenData(value);
    form.setFieldsValue({
      management_scope_id: value.id,
      management_scope_name: value.name,
    });
  };
  const handleDeleteChosenManagementScope = () => {
    setChosenData(null);
    form.setFieldsValue({
      institution_id: null,
      management_scope_id: null,
      management_scope_name: null,
    });
  };
  return (
    <div className={styles["select-management-scope"]}>
      <Select
        showSearch
        placeholder={placeholder}
        filterOption={false}
        onSearch={handleInputChange}
        notFoundContent={isLoading ? <Spin size="small" /> : null}
        options={options}
        optionRender={(option) => renderItem(option)}
        searchValue={query}
        disabled={!form.getFieldValue("institution_id")}
      />
      {chosenData && (
        <div className={styles["chosen-scope"]}>
          <div className={styles["management-scope-info"]}>
            <p className={styles["management-scope-name"]}>
              {chosenData?.name}
            </p>
            <p>{chosenData?.institution_name}</p>
            <Tag>Level {chosenData.level}</Tag>
          </div>
          <div
            className={styles["delete-chosen-profile"]}
            onClick={handleDeleteChosenManagementScope}
          >
            {IconPack.close_icon}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectManagementScopeUnit;
